import React from 'react';
import Button from '../ui/Button';
import FlowLine from '../ui/FlowLine';
import WavyBackground from '../ui/WavyBackground';
import ScrollReveal from '../ui/ScrollReveal';
import { ArrowRight, Play, Heart } from 'lucide-react';
interface HeroSectionProps {
  onWatchDemo: () => void;
}
const HeroSection: React.FC<HeroSectionProps> = ({
  onWatchDemo
}) => {
  return <section className="relative pt-32 pb-24 px-6 md:px-12 lg:px-24 overflow-hidden bg-gradient-to-br from-[#3D52A0] via-[#7091E6] to-[#EDE8F5]" data-id="element-315">
      {/* Animated wave backgrounds */}
      <WavyBackground className="bottom-0 h-24" opacity={0.1} data-id="element-316" />
      <WavyBackground className="top-20 h-32" color="#EDE8F5" opacity={0.1} data-id="element-317" />
      {/* Flow lines */}
      <FlowLine className="top-20 left-0 w-full h-24" data-id="element-318" />
      <FlowLine className="bottom-10 left-0 w-full h-24 rotate-180" color="#EDE8F5" data-id="element-319" />
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-320">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-321">
          <ScrollReveal data-id="element-322">
            <div className="text-white" data-id="element-323">
              <span className="inline-block px-4 py-1 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6 border border-white/20" data-id="element-324">
                Made with{' '}
                <Heart size={14} className="inline mx-1 text-red-400" data-id="element-325" /> by your
                friends at Text In Church.
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-326">
                You plan the outreach events.{' '}
                <span className="bg-gradient-to-r from-yellow-200 to-yellow-100 text-transparent bg-clip-text" data-id="element-327">
                  We handle the communications.
                </span>
              </h1>
              <p className="text-xl md:text-2xl mb-8 opacity-90" data-id="element-328">
                A free AI-powered tool that helps churches reach more people—by
                generating ready-to-send messages for every outreach event.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-329">
                <a href="https://app.shepherdflow.ai/signup" data-id="element-330">
                  <Button variant="accent" size="lg" icon={<ArrowRight size={18} data-id="element-332" />} className="shadow-lg shadow-[#3D52A0]/30" data-id="element-331">
                    Start Free
                  </Button>
                </a>
                <Button variant="secondary" size="lg" icon={<Play size={18} data-id="element-334" />} className="bg-white/20 border-white text-white hover:bg-white/30" onClick={onWatchDemo} data-id="element-333">
                  Watch Demo
                </Button>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={300} data-id="element-335">
            <div className="flex justify-center" data-id="element-336">
              <div className="relative bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-white/20 transform hover:rotate-1 transition-transform duration-500 animate-float" data-id="element-337">
                {/* Updated image to show the actual Shepherd Flow AI interface */}
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x1bjFiUw85oWxz2nwcaupa/2025-10-09_14-35-35.png" alt="Shepherd Flow AI Dashboard showing campaign strategy" className="w-full rounded-lg shadow-lg" data-id="element-338" />
                {/* Updated floating elements with new text */}
                <div className="absolute -top-4 -right-4 bg-white p-2 rounded-lg shadow-lg rotate-3 animate-float" style={{
                animationDelay: '1s'
              }} data-id="element-339">
                  <div className="flex items-center gap-2" data-id="element-340">
                    <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-341"></div>
                    <span className="text-sm font-medium" data-id="element-342">custom emails</span>
                  </div>
                </div>
                <div className="absolute -bottom-4 -left-4 bg-white p-2 rounded-lg shadow-lg -rotate-2 animate-float" style={{
                animationDelay: '2s'
              }} data-id="element-343">
                  <div className="flex items-center gap-2" data-id="element-344">
                    <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-345"></div>
                    <span className="text-sm font-medium" data-id="element-346">
                      engaging social posts
                    </span>
                  </div>
                </div>
                <div className="absolute top-1/2 -left-6 bg-white p-2 rounded-lg shadow-lg rotate-6 animate-float" style={{
                animationDelay: '1.5s'
              }} data-id="element-347">
                  <div className="flex items-center gap-2" data-id="element-348">
                    <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-349"></div>
                    <span className="text-sm font-medium" data-id="element-350">
                      personal text messages
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
};
export default HeroSection;